import React from 'react';
import { ConfirmModal } from 'components/shared/ConfirmModal';

export const CancelPaymentModal = ({ show, transaction, confirmState, isLoading, onConfirm, onClose=
    ()=>{}
 }) => {
  const messages = {
    pending: {
      title: "Cancel Payment Link",
      description: "Are you sure you want to cancel this payment link? This action cannot be undone.",
      actionText: "Yes, Cancel Link",
    },
    success: {
      title: "Payment Link Cancelled",
      description: "The payment link has been successfully cancelled.",
      actionText: "Done",
    },
  };

  return (
    <ConfirmModal
      show={show}
      messages={messages}
      onOk={onConfirm}
      onClose={onClose}
      state={confirmState}
      confirmLoading={isLoading}
    />
  );
};
